function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "grad2",
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#cc31ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "90%",
  stopColor: "#19f2c8"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#grad2)",
  d: "M47.675 12.325L44.15 15.85C47.75 19.475 50 24.475 50 30c0 11.05-8.95 20-20 20s-20-8.95-20-20c0-10.2 7.625-18.6 17.5-19.825v5.05C20.4 16.425 15 22.575 15 30c0 8.275 6.725 15 15 15s15-6.725 15-15c0-4.15-1.675-7.9-4.4-10.6l-3.525 3.525C38.875 24.75 40 27.25 40 30c0 5.525-4.475 10-10 10s-10-4.475-10-10c0-4.65 3.2-8.525 7.5-9.65v5.35C26 26.575 25 28.15 25 30c0 2.75 2.25 5 5 5s5-2.25 5-5c0-1.85-1-3.45-2.5-4.3V5H30C16.2 5 5 16.2 5 30s11.2 25 25 25 25-11.2 25-25c0-6.9-2.8-13.15-7.325-17.675z",
  opacity: 0.654
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M0 0h60v60H0z"
}));

var SvgTeam = function SvgTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeam, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/team.cb7a0183.svg";
export { ForwardRef as ReactComponent };